var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "25px",
    viewBox: "0 0 13 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "06-facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-D---CDP",
    transform: "translate(-1173.000000, -7697.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer-updated",
    transform: "translate(0.000000, 7536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-DSK/V1",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(1116.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06-facebook",
    transform: "translate(57.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,7.81756809 L8.57265681,7.81756809 L8.57265681,5.31182837 C8.57265681,4.37080167 9.2953938,4.15141201 9.80443692,4.15141201 C10.3123218,4.15141201 12.9287687,4.15141201 12.9287687,4.15141201 L12.9287687,0.0144927108 L8.6259355,0 C3.84938525,0 2.76238418,3.08544815 2.76238418,5.05995505 L2.76238418,7.81756809 L0,7.81756809 L0,12.080424 L2.76238418,12.080424 C2.76238418,17.5511725 2.76238418,24.1428571 2.76238418,24.1428571 L8.57265681,24.1428571 C8.57265681,24.1428571 8.57265681,17.4862052 8.57265681,12.080424 L12.4932733,12.080424 L13,7.81756809 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.80d18b30be53732f82a9dc00a54edfe8.svg";
export { ForwardRef as ReactComponent };